import React from "react";

const TutorialStepsSection = () => {
  return (
    <section className='step py-80'>
      <div className='position-relative z-1'>
        <img
          src='assets/images/shape/curve-line-shape.png'
          alt=''
          className='position-absolute top-0 inset-inline-end-0 z-n1 me-60 d-lg-block d-none'
        />
        <div className='container container-lg'>

          <div className='section-heading text-center mx-auto mb-60'>
            <h5 className=''>Your Fun Card Journey — Step by Step</h5>
            <span className='text-gray-600'>
              Everything you need to know, from discovering coupons to redeeming your savings
            </span>
          </div>

          <div className='row gy-4'>

            {/* Left column: Steps 1–4 */}
            <div className='col-lg-6'>
              <div className='step-content'>
                <div className='d-flex flex-column align-items-end gap-56'>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 01</h5>
                      <p className='text-gray-600'>
                        Discover a coupon in a city you love. Browse by category, location, or keyword on the Fun Card shop to find deals near you.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        01
                      </h6>
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 02</h5>
                      <p className='text-gray-600'>
                        Purchase the Fun Card access pass to unlock access to all available coupons for an entire year — one low price, unlimited savings.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        02
                      </h6>
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 03</h5>
                      <p className='text-gray-600'>
                        Download the Fun Card iOS or Android app for quick, always-available coupon access right from your pocket.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        03
                      </h6>
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 04</h5>
                      <p className='text-gray-600'>
                        Bookmark your favorite coupons while logged in so they're always one tap away when you're ready to head out.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        04
                      </h6>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* Right column: Steps 5–7 */}
            <div className='col-lg-6'>
              <div className='step-content'>
                <div className='d-flex flex-column align-items-start gap-56'>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        05
                      </h6>
                    </div>
                    <div className='text-start'>
                      <h5 className='mb-8'>Step 05</h5>
                      <p className='text-gray-600'>
                        Head to the business location and enjoy the experience. The coupon is redeemed in person, keeping things simple for you and the business.
                      </p>
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        06
                      </h6>
                    </div>
                    <div className='text-start'>
                      <h5 className='mb-8'>Step 06</h5>
                      <p className='text-gray-600'>
                        Show your coupon to the server before you order, or present it alongside your receipt after the meal — either way works to claim your discount.
                      </p>
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-32'>
                    <div className='w-90 h-90 flex-center bg-main-two-100 rounded-circle flex-shrink-0'>
                      <h6 className='mb-0 w-60 h-60 bg-main-two-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        07
                      </h6>
                    </div>
                    <div className='text-start'>
                      <h5 className='mb-8'>Step 07</h5>
                      <p className='text-gray-600'>
                        Once a coupon is redeemed, it's used for that subscription period. Re-purchase your Fun Card subscription at any time to reset all coupons and start saving all over again.
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TutorialStepsSection;
